var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "subscription-item",
    class: {
      'loading': _vm.loading,
      'disabled': _vm.disabled,
      'unfollowed': !_vm.subscription.isActive
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click', _vm.subscription);
      }
    }
  }, [_c('subscription-icon', {
    attrs: {
      "color-image": _vm.colorImage,
      "subscription-name": _vm.subscription.name,
      "unfollowed": !_vm.subscription.isActive,
      "loading": _vm.loading,
      "disabled": _vm.disabled
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "label",
    class: {
      'loading': _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.subscriptionLabel))]), _c('span', {
    staticClass: "periodicity",
    class: {
      'loading': _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.writeOffVariant))]), _vm.isShownNextPay ? _c('span', {
    staticClass: "next-pay"
  }, [_c('cs-icon', {
    attrs: {
      "color": _vm.colorImage,
      "name": "calendar",
      "container-size": "extra-small"
    }
  }), _c('span', {
    staticClass: "next-pay-text"
  }, [_vm._v(_vm._s(_vm.nextPay))])], 1) : _vm._e()]), _c('div', {
    staticClass: "sum",
    class: {
      'loading': _vm.loading
    }
  }, [_vm._v(" " + _vm._s(_vm.displayOverallAmount) + " ")]), _c('unsubscribe-button', {
    attrs: {
      "active": _vm.subscription.isActive,
      "loading": _vm.loading,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClickUnfollow
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }